/**
 * Local models loaded in LM Studio. This is the only list the local-model
 * dropdowns use (Checking, Recheck, Sort, MCQ OMR, curriculum).
 */
export const LOCAL_MODELS = [
  { value: 'qwen38_27b', label: 'qwen/qwen3.8-27b' },
  { value: 'qwen25vl_7b_pure_q5km', label: 'Smoffyy/Qwen2.5-VL-7B-Instruct-Pure-GGUF Q8_K_M' },
  { value: 'qwen35_4b_revised', label: 'Smoffyy/qwen3.5-4b-instruct-revised' },
  { value: 'ggml', label: 'ggml-org/gemma-4-31b-it' },
];

const LOCAL_MODEL_KEYS = new Set(LOCAL_MODELS.map((m) => m.value));

/** True when `value` is one of the four local models shown in the dropdowns. */
export function isKnownLocalModel(value) {
  return LOCAL_MODEL_KEYS.has(value);
}

export const GEMINI_MODELS = [
  { value: 'gemini-3.8-flash', label: '3.8-flash' },
  { value: 'gemini-3.6-flash', label: '3.6-flash' },
  { value: 'gemini-3.1-pro-preview', label: '3.1-pro-preview (2-12)' },
  { value: 'gemini-3.1-flash-lite-preview', label: '3.1-flash-lite-preview (0.25-1.5)' },
  { value: 'gemini-3.1-flash-live-preview', label: '3.1-flash-live-preview (1-4.5)' },
  { value: 'gemini-3.1-flash-image-preview', label: '3.1-flash-image-preview (0.5-3)' },
  { value: 'gemini-3-flash-preview', label: '3-flash-preview (0.5-3)' },
  { value: 'gemini-3-pro-image-preview', label: '3-pro-image-preview (2-12)' },
  { value: 'gemini-2.5-pro', label: '2.5-pro (1.25-10)' },
  { value: 'gemini-2.5-flash', label: '2.5-flash (0.3-2.5)' },
  { value: 'gemini-2.5-flash-lite', label: '2.5-flash-lite (0.1-0.4)' },
];

/** ChatGPT models an examiner can try on the rubric Generate page. */
export const OPENAI_MODELS = [
  { value: 'gpt-5.4', label: 'gpt-5.4' },
  { value: 'gpt-5.4-mini', label: 'gpt-5.4-mini' },
  { value: 'gpt-5.2', label: 'gpt-5.2' },
  { value: 'gpt-5', label: 'gpt-5' },
  { value: 'gpt-5-mini', label: 'gpt-5-mini' },
  { value: 'gpt-4.1', label: 'gpt-4.1' },
  { value: 'gpt-4.1-mini', label: 'gpt-4.1-mini' },
  { value: 'gpt-4.1-nano', label: 'gpt-4.1-nano' },
  { value: 'gpt-4o', label: 'gpt-4o' },
  { value: 'gpt-4o-mini', label: 'gpt-4o-mini' },
];

export const MINIMAX_MODELS = [
  { value: 'MiniMax-M2', label: 'MiniMax-M2 (text, latest)' },
  { value: 'MiniMax-M1', label: 'MiniMax-M1 (text, reasoning)' },
  { value: 'MiniMax-Text-01', label: 'MiniMax-Text-01 (text)' },
];

/** Examiner rubric-page choice: local:<key>, openai:<model>, or gemini:<model>. */
export function isRubricModelChoice(value) {
  if (value === 'openai') return true;
  if (typeof value !== 'string') return false;
  if (value.startsWith('local:')) return isKnownLocalModel(value.slice(6));
  if (value.startsWith('openai:')) {
    const id = value.slice(7);
    return OPENAI_MODELS.some((m) => m.value === id);
  }
  if (value.startsWith('gemini:')) {
    const id = value.slice(7);
    return GEMINI_MODELS.some((m) => m.value === id);
  }
  return false;
}
